export const questions = {
  '1534622231816': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T19:57:11.817Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-29T20:20:09.703Z',
    },
    answers: [
      {
        answer: 'I really enjoy taking care of others',
        score: '10',
        uniqueKey: 'B1b1Fe8UX',
      },
      {
        answer: 'I like to receive a little more than I like to give',
        score: '1',
        uniqueKey: 'r1Yh_eL8m',
      },
      {
        answer: 'I like to give, but I also like to receive ',
        score: '',
        uniqueKey: 'SkQ2ueLL7',
      },
      {
        answer: 'I like to give a little more than I like to receive ',
        score: '6',
        uniqueKey: 'BJlR_xUIX',
      },
    ],
    category: [1534053372201],
    description: [1540588518014],
    id: 1534622231816,
    personality: [1534053563681, 1534053577553, 1534053570670, 1534053589013],
    question: 'How would you define yourself?',
  },
  '1534622323124': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T19:58:43.124Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-29T20:20:40.766Z',
    },
    answers: [
      {
        answer: 'Always been faithful to his partners, even if things got bad ',
        score: '',
        uniqueKey: 'S1zS9lLUX',
      },
      {
        answer:
          '...Well he was “technically” in a relationship when we met, but that relationship was emotionally over',
        score: '10',
        uniqueKey: 'Hydw5gIIX',
      },
      {
        answer:
          'Looked for comfort in another person while leaving a difficult relationship',
        score: '4',
        uniqueKey: 'HyvHcx88Q',
      },
      {
        answer: 'Cheated on a partner at least once',
        score: '8',
        uniqueKey: 'B1wIqgIUX',
      },
    ],
    category: [1534053372201],
    description: [1540588536810],
    id: 1534622323124,
    personality: [1534053570670],
    question: 'In past relationships, he has:',
  },
  '1534622409357': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:00:09.357Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-12-05T02:23:10.289Z',
    },
    answers: [
      {
        answer: 'As far as I know, he’s been fully honest with me',
        score: '2',
        uniqueKey: 'SJ3iclIL7',
      },
      {
        answer:
          "Yes he's lied or covered up something, and I was upset about it",
        score: '10',
        uniqueKey: 'r1U65eU8m',
      },
      {
        answer: 'He is always truthful even if it’s a hard thing to say',
        score: '',
        uniqueKey: 'ryeocg8UX',
      },
      {
        answer: "He's lied once or twice, but they were small things",
        score: '9',
        uniqueKey: 'B1F3ql8IX',
      },
    ],
    category: [1534053372201],
    description: [1534650318258],
    id: 1534622409357,
    personality: [1534053570670],
    question: 'Has he ever been dishonest with you?',
  },
  '1534623063982': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:11:03.983Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-31T02:06:32.476Z',
    },
    answers: [
      {
        answer:
          'I feel mostly content and feel we can work through any issues ',
        score: '3',
        uniqueKey: 'H1QNagLLX',
      },
      {
        answer: 'Sometimes I feel amazing and sometimes I feel confused',
        score: '10',
        uniqueKey: 'H1k86lL8Q',
      },
      {
        answer: 'I feel secure in knowing there is a real future between us',
        score: '',
        uniqueKey: 'B1sm6lLUm',
      },
      {
        answer: "Sometimes I feel like the relationship isn't moving forward",
        score: '9',
        uniqueKey: 'H1GBTgLI7',
      },
    ],
    category: [1534053384042],
    description: [1540588576917],
    id: 1534623063982,
    personality: [1534053570670, 1534053589013, 1534053577553],
    question: 'How does the relationship make you feel?',
  },
  '1534623139853': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:12:19.854Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-31T02:05:35.655Z',
    },
    answers: [
      {
        answer: '“I’m open to all possibilities”',
        score: '5',
        uniqueKey: 'rkxq6g88X',
      },
      {
        answer: '“I’m looking for my life partner”',
        score: '',
        uniqueKey: 'r1lK6lIIm',
      },
      {
        answer: '“I really like you. Let’s see how it goes”',
        score: '10',
        uniqueKey: 'Sy3qTx8LQ',
      },
      {
        answer: '“I don’t want to settle, but I’m ready to find her”',
        score: '2',
        uniqueKey: 'H14Kpx8LX',
      },
    ],
    category: [1534053384042],
    description: [1534053522629],
    id: 1534623139853,
    personality: [1534053570670],
    question: 'When you ask him about his dating objectives, he says:',
  },
  '1534623442448': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:17:22.448Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-11-12T16:49:48.865Z',
    },
    answers: [
      {
        answer: 'He has a strong reputation for being someone you can count on',
        score: '',
        uniqueKey: 'HJctRgLU7',
      },
      {
        answer: 'He has to be the “bad guy” sometimes because he’s the boss',
        score: '10',
        uniqueKey: 'Bk2hClLU7',
      },
      {
        answer:
          'He talks about how hard it is to have good relationships at work ',
        score: '8',
        uniqueKey: 'r1Di0eI87',
      },
      {
        answer: 'There is a lot of mutual respect and he is generally liked ',
        score: '1',
        uniqueKey: 'HkFcRg887',
      },
    ],
    category: [1534053400376],
    description: [1540844348307],
    id: 1534623442448,
    personality: [1534053589013],
    question:
      'What sentence best describes his relationship with his coworkers and colleagues:',
  },
  '1534624058648': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:27:38.648Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-12-04T03:26:00.258Z',
    },
    answers: [
      {
        answer: 'Doesn’t have a job that allows him to save much money',
        score: '5',
        uniqueKey: 'ryxmbWIUm',
      },
      {
        answer:
          'Isn’t saving much money right now and tends to splurge more than he should',
        score: '10',
        uniqueKey: 'BkRQbbUUX',
      },
      {
        answer:
          'Is actively saving money, so that he has more freedom in the future',
        score: '2',
        uniqueKey: 'ryQfWZII7',
      },
      {
        answer: 'Is very responsible with money no matter how much he has',
        score: '',
        uniqueKey: 'r1yz--ILm',
      },
    ],
    category: [1534053393283],
    description: [1540588709864],
    id: 1534624058648,
    personality: [1534053563681],
    question: 'When it comes to his personal assets, he:',
  },
  '1534624153698': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:29:13.698Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-11-12T16:50:51.190Z',
    },
    answers: [
      {
        answer:
          'Wants to be doing something else, but currently isn’t making any actions towards it',
        score: '10',
        uniqueKey: 'BJVYb-LU7',
      },
      {
        answer: 'Is thinking about his next move and making calculations ',
        score: '2',
        uniqueKey: 'S1MPWb8Lm',
      },
      {
        answer: 'Is passionate about what he does and is building upon it',
        score: '',
        uniqueKey: 'ryCUZ-UIX',
      },
      {
        answer:
          'Likes his job well enough and wants to keep things as they are',
        score: '7',
        uniqueKey: 'rJg_W-8IQ',
      },
    ],
    category: [1534053393283],
    description: [1534053539894],
    id: 1534624153698,
    personality: [1534053563681],
    question: 'When it comes to his work, he:',
  },
  '1534624234375': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:30:34.375Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-11-12T16:52:00.472Z',
    },
    answers: [
      {
        answer: 'Gets it done (but sometimes it seems inconvenient to him)',
        score: '7',
        uniqueKey: 'HJQTZbUUQ',
      },
      {
        answer: 'Gives you suggestions on how to get it done',
        score: '8',
        uniqueKey: 'SyM0WZUUX',
      },
      {
        answer: 'Listens to your needs, but doesn’t always offer help',
        score: '10',
        uniqueKey: 'HkIyzbI8m',
      },
      {
        answer: 'Gets it done (with a smile)',
        score: '',
        uniqueKey: 'Sy1pbbLIm',
      },
    ],
    category: [1534053400376],
    description: [1540588727344],
    id: 1534624234375,
    personality: [1534053589013, 1534053577553],
    question: 'If you mention you need something done, he...',
  },
  '1534624311344': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:31:51.344Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-12-05T02:53:46.294Z',
    },
    answers: [
      {
        answer:
          'He gets frustrated, defensive or angry pretty quickly before settling down',
        score: '10',
        uniqueKey: 'HJCQGZ8UX',
      },
      {
        answer:
          'He struggles to respond, but always tries with good intentions',
        score: '2',
        uniqueKey: 'SJQzMW8Um',
      },
      {
        answer:
          'He communicates with ease, even if he has something difficult to talk about ',
        score: '',
        uniqueKey: 'r1AbzWLL7',
      },
      {
        answer: "He gets quiet and you're wondering what he's thinking",
        score: '6',
        uniqueKey: 'rke7G-IIm',
      },
    ],
    category: [1534053393283],
    description: [1540844302166],
    id: 1534624311344,
    personality: [1534053563681, 1534053589013],
    question: 'When there is a conflict, your man’s IMMEDIATE response is…',
  },
  '1534624418012': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:33:38.012Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-31T02:09:02.851Z',
    },
    answers: [
      {
        answer:
          'Is nice to their face, but likes to make negative comments about them or their service as soon as they leave ',
        score: '9',
        uniqueKey: 'Byz1SddII7',
      },
      {
        answer: 'Notices when things go wrong, but brushes it off ',
        score: '2',
        uniqueKey: 'B1ekBddI8Q',
      },
      {
        answer:
          'Seems impatient at times or gets frustrated with how they do their jobs',
        score: '10',
        uniqueKey: 'H1W1BO_UUm',
      },
      {
        answer: 'Overall kindly and easily gets over bad service ',
        score: '',
        uniqueKey: 'SJkHd_LLm',
      },
    ],
    category: [1534053400376],
    description: [1540844325058],
    id: 1534624418012,
    personality: [1534053589013],
    question:
      'When you are out and about, how does he treat servers, waitstaff and grocery store clerks?',
  },
  '1534624491837': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-18T20:34:51.838Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-29T20:25:45.467Z',
    },
    answers: [
      {
        answer: 'Might correct you if he feels you didn’t say something right ',
        score: '10',
        uniqueKey: 'rkmk7-UU7',
      },
      {
        answer: 'Wants to know more, so he’ll ask a bunch of questions',
        score: '',
        uniqueKey: 'H1MTGbU8X',
      },
      {
        answer: 'Doesn’t interrupt you and seems engaged',
        score: '1',
        uniqueKey: 'rJPpfbIUm',
      },
      {
        answer: 'Sometimes cuts you off abruptly ',
        score: '9',
        uniqueKey: 'HkfRfZLUQ',
      },
    ],
    category: [1534053400376],
    description: [1540588740505],
    id: 1534624491837,
    personality: [1534053589013],
    question: 'When talking together, he:',
  },
  '1535569640340': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:07:20.341Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-29T20:26:08.359Z',
    },
    answers: [
      {
        answer: 'Looks around a lot at people or commotion',
        score: '3',
        uniqueKey: 'ryrj0DEwX',
      },
      {
        answer: 'Makes you feel as if you are the center of his attention',
        score: '',
        uniqueKey: 'H1xjAPVwQ',
      },
      {
        answer: 'Holds a glance or stares at other women',
        score: '9',
        uniqueKey: 'Bkm20PNDX',
      },
      {
        answer: 'Points out to you an attractive woman that walks by',
        score: '10',
        uniqueKey: 'rkk6RP4Pm',
      },
    ],
    category: [1534053372201],
    description: [1540844283451],
    id: 1535569640340,
    personality: [1534053570670],
    question: 'When at a restaurant enjoying dinner together, your man:',
  },
  '1535569748565': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:09:08.565Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-29T20:26:41.528Z',
    },
    answers: [
      {
        answer: 'Immediately handles it, even if his delivery is rough',
        score: '1',
        uniqueKey: 'H10MJuEwQ',
      },
      {
        answer:
          'Thinks about how to handle it and then confronts the situation',
        score: '',
        uniqueKey: 'Sk5zJd4vm',
      },
      {
        answer: 'Generally ignores the situation hoping it will go away',
        score: '9',
        uniqueKey: 'Bk0myONvQ',
      },
      {
        answer: 'Gets into his head and over-thinks at times',
        score: '10',
        uniqueKey: 'HyerkOEDQ',
      },
    ],
    category: [1534053372201],
    description: [1534053530954],
    id: 1535569748565,
    personality: [1534053577553],
    question: 'When it comes to problem-solving, your man:',
  },
  '1535569990595': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:13:10.595Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-29T20:27:17.937Z',
    },
    answers: [
      {
        answer: 'Experienced a lot of turbulence ',
        score: '5',
        uniqueKey: 'BJYGluEwX',
      },
      {
        answer: "Realized they weren't compatible",
        score: '',
        uniqueKey: 'S1gGxO4DQ',
      },
      {
        answer: 'Experienced a cold relationship ',
        score: '8',
        uniqueKey: 'H1GmeuEv7',
      },
      {
        answer: 'Got cheated on',
        score: '10',
        uniqueKey: 'rJBNxd4wQ',
      },
    ],
    category: [1534053384042],
    description: [1540844243345],
    id: 1535569990595,
    personality: [1534053577553],
    question: 'In past relationships, your man:',
  },
  '1535570169729': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:16:09.730Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-12-05T02:41:13.369Z',
    },
    answers: [
      {
        answer: 'Went through counseling to resolve any issues from the past',
        score: '2',
        uniqueKey: 'zrXWfzETF',
      },
      {
        answer: 'Continues to have issues with his ex',
        score: '9',
        uniqueKey: 'nEufIt8hOk',
      },
      {
        answer:
          'Still struggles at times with feelings of guilt, fear and/or sadness',
        score: '10',
        uniqueKey: 'Wn1z6o1uXX',
      },
      {
        answer:
          'Spent a lot of time reflecting on the situation(s) and has resolution',
        score: '',
        uniqueKey: 'vc4anZp04d',
      },
    ],
    category: [1534053384042],
    description: [1540588689624],
    id: 1535570169729,
    personality: [1534053577553],
    question: 'When it comes to past relationships, your man:',
  },
  '1535570278011': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:17:58.011Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-12-05T02:42:41.773Z',
    },
    answers: [
      {
        answer:
          'He is very flexible and does his best so that you two can get together',
        score: '2',
        uniqueKey: 'By-EWuNP7',
      },
      {
        answer:
          'You regularly see each other, and enjoy the balance of going out and staying in',
        score: '',
        uniqueKey: 'Bk87WdEP7',
      },
      {
        answer:
          'He makes plans and keeps them, with the occasional last-minute cancellation',
        score: '10',
        uniqueKey: 'Syl8ZuEPm',
      },
      {
        answer:
          'At times, he turns down plans citing other personal responsibilities or side obligations that take priority',
        score: '9',
        uniqueKey: 'BkQrW_EDX',
      },
    ],
    category: [1534053384042],
    description: [1540844273320],
    id: 1535570278011,
    personality: [1534053570670],
    question: 'Which statement feels most like your relationship?',
  },
  '1535570528455': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:22:08.455Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-31T02:10:53.400Z',
    },
    answers: [
      {
        answer: 'I’m thinking he probably has one vice',
        score: '10',
        uniqueKey: 'BkMeaiXVd7',
      },
      {
        answer: 'I did suspect at one time, but not anymore',
        score: '6',
        uniqueKey: 'rkWeaiQ4_X',
      },
      {
        answer: "I haven't ever suspected he has any addictions",
        score: '',
        uniqueKey: 'HyxaimE_Q',
      },
      {
        answer: "Probably not, but I'm keeping an eye on it just to be sure",
        score: '8',
        uniqueKey: 'Byegpjm4um',
      },
    ],
    category: [1534053393283],
    description: [1540588824868],
    id: 1535570528455,
    personality: [1534053577553],
    question:
      'Do you suspect or wonder If your man has any addictions (alcohol, porn…)?',
  },
  '1535570729908': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:25:29.908Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-12-05T02:34:26.318Z',
    },
    answers: [
      {
        answer: 'He works hard and it’s paying off',
        score: '',
        uniqueKey: 'XrF8S5TuR2',
      },
      {
        answer: 'He has personal goals',
        score: '2',
        uniqueKey: 'rOFmOQXmt',
      },
      {
        answer:
          'He doesn’t have a plan for life and that makes me feel a bit nervous',
        score: '10',
        uniqueKey: 'bBSnJH-1Uj',
      },
      {
        answer: 'He goes with the flow and takes life day by day',
        score: '8',
        uniqueKey: 'LLYe8ihUqF',
      },
    ],
    category: [1534053393283],
    description: [1540844315636],
    id: 1535570729908,
    personality: [1534053563681],
    question: 'How does your man plan for the future?',
  },
  '1535570975564': {
    __meta__: {
      createdBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      createdDate: '2018-08-29T19:29:35.564Z',
      lastModifiedBy: 'Vmmgi6G0sNbDGubbaj2AvWvCqcB2',
      lastModifiedDate: '2018-10-29T20:31:14.838Z',
    },
    answers: [
      {
        answer:
          'Doesn’t have any animals as pets and really doesn’t want any for right now',
        score: '10',
        uniqueKey: 'HJbWE_VDQ',
      },
      {
        answer: 'Has a dog, but doesn’t seem to have a real connection',
        score: '9',
        uniqueKey: 'H18eEO4wX',
      },
      {
        answer: 'Has a dog, but doesn’t like cats',
        score: '8',
        uniqueKey: 'BypkN_4w7',
      },
      {
        answer: 'Has a strong connection with animals and wildlife in general',
        score: '',
        uniqueKey: 'Skmy4uED7',
      },
    ],
    category: [1534053400376],
    description: [1540844335519],
    id: 1535570975564,
    personality: [1534053589013],
    question: 'What statement best describes his relationship with animals?',
  },
};



// WEBPACK FOOTER //
// ./src/api/data/_questions-data.js